import "../../stylesheets/App.css";
import "../../stylesheets/PopupRegister.css";
import React from "react";

function PopupConfirmDeactivateUser(props) {
  const closePopups = () => {
    props.setDeactivateUser(-1);
    props.setFinished(false);
    props.setRefresh(true);
  };

  return (
    <>
      <div className="popup-register-container popup-deactivate-user popup-confirm-deactive-user">
        <div className="popup">
          <div className="lightgreen">
            <img
              src={
                process.env.PUBLIC_URL +
                "/images/stage_characters/Popup_Imagen.png"
              }
              alt=""
            />
          </div>
          <h1>Usuario eliminado con éxito</h1>
          <button className="btn lightgreen-btn" onClick={closePopups}>
            Volver al inicio
          </button>
        </div>
      </div>
    </>
  );
}

export default PopupConfirmDeactivateUser;
